// 是否预览
export const IS_PREVIEW = location.pathname === 'srcdoc';
export const _ROUTE_STACKS = '_route_stacks';
